<template>
  <div class="main-clock px-8">
    <div class="flex flex-wrap -mx-8 text-white items-center px-4 pt-2">
      <div class="w-6/12 px-8 text-5xl text-center">
        <p class="uppercase p-2 font-black">{{weekday}}</p>
        <div class="hr bg-blue-100"></div>
        <p class="p-2">{{date}}</p>
      </div>
      <div class="w-6/12 pr-8 text-right">
        <p class="text-9xl font-extrabold">{{time}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  now,
  getDay,
  formatDateLocaleVN,
  formatTime
} from '../../../utils/date'

export default {
  data() {
    return {
      secInterval: 5,
      timer: null,
      date: null,
      time: null,
      weekday: null
    }
  },
  created() {
    this.calcDateTime()
  },
  mounted() {
    this.timer = setInterval(() => {
      this.calcDateTime()
    }, this.secInterval * 1000)
  },
  methods: {
    calcDateTime() {
      const date = now()
      this.weekday = getDay(date)
      this.date = formatDateLocaleVN(date)
      this.time = formatTime(date)
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style>

</style>